/**
 * Jotai atoms for orders report state management
 * Manages report data, loading states, and pagination
 */

import { atom } from 'jotai';

import type { OrderDisplayStatusType } from '@common/lib/reports';

// Report data from API - matches backend generateSalesByCustomerNameReportData response
// Fields ordered to match UI table display
export interface OrderReportItem {
	// Identifiers
	placedOrderId: string;
	uid: string;
	formattedVin: string;
	customer: string;

	// Dates (timestamps)
	date: number | string;
	deliveryDate?: number | string;
	dispatchDate?: number | string;

	// Pricing breakdown
	basePrice: number | string;
	addOns: number | string;
	totalDiscount: number | string;
	vehiclePriceNoFees: number | string;
	taxes: number | string;
	altGovFees: number | string;
	deliveryFee: number | string;
	pickUpFee: number | string;
	buyerCoveredProcessingFees: number | string;
	totalDue: number | string;

	// Payment amounts
	paidByCustomer: number | string;
	paidByCustomerOffPlatform: number | string;
	paidByLender: number | string;
	totalPaid: number | string;

	// Invoice and client amounts
	invoicePrice: number | string;
	oemCollectedShippingFees: number | string; // Client collected shipping fees
	grossOemOwed: number | string; // Gross client owed

	// Status and metadata
	vehiclePaymentStatus: string;
	paymentNotes: string;
	disputeStatus: string;
	externalStatus: string;

	// Backend-only fields (not displayed in UI table)
	vehicleFulfillmentStatus?: string;

	// Computed fields for display (derived from vehiclePaymentStatus)
	status?: OrderDisplayStatusType;
}

// Orders report data atom
export const ordersReportDataAtom = atom<OrderReportItem[] | null>(null);

// Loading state atom
export const isGeneratingOrdersReportAtom = atom<boolean>(false);

// Pagination atoms
export const currentPageAtom = atom<number>(1);
export const itemsPerPageAtom = atom<number>(50);
